// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_mask_phone {
   display: block;
   width: 100%;
   padding: .375rem .75rem;
   font-size: 1rem;
   font-weight: 400;
   line-height: 1.5;
   color: var(--bs-body-color);
   appearance: none;
   background-color: var(--bs-body-bg);
   background-clip: padding-box;
   border: var(--bs-border-width) solid var(--bs-border-color);
   border-radius: var(--bs-border-radius);
   transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.input_mask_phone:focus {
   color: var(--bs-body-color);
   background-color: var(--bs-body-bg);
   border-color: #86b7fe;
   outline: 0;
   box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);
}`, "",{"version":3,"sources":["webpack://./src/styles/input_mask.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,WAAW;GACX,uBAAuB;GACvB,eAAe;GACf,gBAAgB;GAChB,gBAAgB;GAChB,2BAA2B;GAC3B,gBAAgB;GAChB,mCAAmC;GACnC,4BAA4B;GAC5B,2DAA2D;GAC3D,sCAAsC;GACtC,sEAAsE;AACzE;;AAEA;GACG,2BAA2B;GAC3B,mCAAmC;GACnC,qBAAqB;GACrB,UAAU;GACV,gDAAgD;AACnD","sourcesContent":[".input_mask_phone {\n   display: block;\n   width: 100%;\n   padding: .375rem .75rem;\n   font-size: 1rem;\n   font-weight: 400;\n   line-height: 1.5;\n   color: var(--bs-body-color);\n   appearance: none;\n   background-color: var(--bs-body-bg);\n   background-clip: padding-box;\n   border: var(--bs-border-width) solid var(--bs-border-color);\n   border-radius: var(--bs-border-radius);\n   transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n\n.input_mask_phone:focus {\n   color: var(--bs-body-color);\n   background-color: var(--bs-body-bg);\n   border-color: #86b7fe;\n   outline: 0;\n   box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
